import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import deferRender from 'defer-render-hoc';

import {
  __getGroupedByDate,
  getNextPageLink,
  getIsJourneysLoading,
  getIsJourneysError,
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
  getIsNextPageLoading,
} from 'redux/modules/journeys/selectors';

import { journeyCardEnhancer } from 'modules/journey/card/hoc';
import { getUnassignedFilters } from 'redux/modules/jobs/selectors';

import { withRouter } from 'react-router-dom';

import Unassigned from './component';

const selectors = {
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
  getFilters: getUnassignedFilters,
};

const enhance = compose(
  injectIntl,
  deferRender,
  withRouter,
  journeyCardEnhancer(selectors),
  connect((state) => {
    const filters = getUnassignedFilters(state);
    const nextPage = getNextPageLink(state);
    return {
      filters,
      loading: getIsJourneysLoading(state),
      hasError: getIsJourneysError(state),
      grouped: __getGroupedByDate(state, filters),
      nextPageLoading: getIsNextPageLoading(state),
      nextPage,
    };
  })
);

export default enhance(Unassigned);
